/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "chainId_",
                type: "uint16",
            },
        ],
        name: "bridgeContracts",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "isTransferCompleted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "isWrappedAsset",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseRegisterChain",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainID",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                ],
                internalType: "struct NFTBridgeStructs.RegisterChain",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "newContract",
                        type: "bytes32",
                    },
                ],
                internalType: "struct NFTBridgeStructs.UpgradeContract",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "registerChain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "splCache",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                ],
                internalType: "struct NFTBridgeStorage.SPLCache",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "tokenChainId",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "tokenAddress",
                type: "bytes32",
            },
        ],
        name: "wrappedAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "transferNFT",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                ],
                internalType: "struct NFTBridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        name: "encodeTransfer",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseTransfer",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                ],
                internalType: "struct NFTBridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
var NFTBridge__factory = /** @class */ (function (_super) {
    __extends(NFTBridge__factory, _super);
    function NFTBridge__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    NFTBridge__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    NFTBridge__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    NFTBridge__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    NFTBridge__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    NFTBridge__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    NFTBridge__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    NFTBridge__factory.bytecode = _bytecode;
    NFTBridge__factory.abi = _abi;
    return NFTBridge__factory;
}(ContractFactory));
export { NFTBridge__factory };
